import { AfterViewInit, Component, OnChanges, SimpleChanges, ViewChild, input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faFire, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-remove-positions',
    templateUrl: './remove-positions.component.html',
    styleUrl: './remove-positions.component.scss',
    standalone: false
})
export class RemovePositionsComponent implements AfterViewInit, OnChanges {
  faFire = faFire;
  faTrash = faTrash;

  positionList = input.required<any>();
  user = input.required<any>();
  updateUser = input.required<Subject<any>>();
  positions = new MatTableDataSource<any>();
  displayedColumns!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort = new MatSort;

  constructor(
    private readonly userService: UserService,
    private readonly toast: ConfirmationToastComponent,  
    private readonly dialogService: DialogService, 
  ) {
    this.displayedColumns = [
      'position',
      'region',
      'forest',
      'delete',
    ]
  }

  ngOnChanges(changes: SimpleChanges) {
    this.positions.data = this.positionList();
  }

  delete(position: any) {
    this.dialogService.openSpinner()
    this.userService.deleteBAERRole(this.user().user_id, position.user_baer_role_id).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`Role Deleted.`);
        // Remove role from local copy
        let roleIndex = this.user().baer_roles.findIndex((role: any) => role.user_baer_role_id == position.user_baer_role_id)
        this.positionList().splice(this.positionList().indexOf(position), 1);
        if (roleIndex != -1) {
          this.user().baer_roles.splice(roleIndex, 1)
        }
        this.positions.data = this.positionList();
        this.updateUser().next(null)
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`Role deleted fail.`, "Please try again.");
      },
      complete: () => {
        this.dialogService.closeSpinner();
        return true;
      },
    });
    // delete position.user_baer_role_id
  }

  ngAfterViewInit() {
    this.positions.sort = this.sort;
    this.positions.paginator = this.paginator;

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }
}
